import*as r from"react";var e=e=>{const t=r.useRef({});return r.useEffect((()=>{t.current=e})),t.current};export{e as u};
